export default class ExportsTemplatesColumnsIndex {

  constructor() {}

  colLetter(index) {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return index < 26
      ? alphabet[index]
      : alphabet[Math.floor(index / 26) - 1] + alphabet[index % 26];
  }

  updateColLetters() {
    $('.template-columns-sortable li').each((index, el) => {
      $(el).find('.col-letter').text(this.colLetter(index));
    });
  }

  render() {

  // Draggable sections https://api.jqueryui.com/sortable
    $('.template-columns-sortable').sortable({
      placeholder: "available-column-space",
      scrollSensitivity: 100,
      cursor: "move",
      handle: ".grip",
      items: "li:not(.unsortable)",
      start: function(event, ui) {
        $('.template-action-buttons .btn').css('opacity', 0);
      },
      stop: function(event, ui) {
        $('.template-action-buttons .btn').css('opacity', 1);
      },
      update: (event, ui) => {
        let sortOrder = $(event.target).sortable('toArray');
        let accountUrl = $('body').attr('data-account-url');
        let templateId = $('.template-columns-sortable').attr('data-template-id');
        let url = '/' + accountUrl + '/exports/templates/' + templateId + '.json?';
        let params = {};
        params['export_template'] = {};
        params['export_template']['columns_attributes'] = {};
        $.each(sortOrder, function(ind, columnId) {
          let id = $('#' + columnId).attr('data-column-id');
          params['export_template']['columns_attributes'][ind] = {};
          params['export_template']['columns_attributes'][ind]['id'] = id;
          params['export_template']['columns_attributes'][ind]['sort_order'] = ind + 1;
        });
        $.ajax({
          type: 'PATCH',
          dataType: 'application/json',
          url: url + $.param(params),
          complete: () => { this.updateColLetters(); }
        });
      }
    });


  }

}
